<template>
  <div v-show="modelValue" class="modal-overlay" @click.self="close">
    <div class="modal-window">
      <header class="modal-header">
        <h3>Рекомендации ИИ</h3>
        <button class="close-btn" @click="close">✕</button>
      </header>

      <section class="modal-body">
        <button :disabled="loading" class="btn primary" @click="getLandingSuggestions">
          Получить рекомендации
        </button>

        <div v-if="loading" class="hint">Загрузка...</div>
        <div v-if="error" class="hint error">{{ error }}</div>

        <div v-if="landingInfo" class="landing-info card">
          <div class="info-grid">
            <p class="span-2"><strong>Описание:</strong> {{ landingInfo.summary }}</p>
          </div>

          <div class="recommendations">
            <h5>Рекомендации</h5>
            <ul>
              <li v-for="(rec, index) in landingInfo.recommendations" :key="index">
                ➜ {{ rec }}
              </li>
            </ul>
          </div>

        

        </div>
      </section>

      <footer class="modal-footer">
        <button class="btn secondary" @click="close">Отмена</button>
        <button class="btn primary" :disabled="!landingInfo" @click="save">
          ОК
        </button>
      </footer>
    </div>
  </div>
</template>


<script>
export default {
  name: 'SuggestionsModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {};
  },
  computed: {
    landingInfo() {
      // Парсим JSON из текста сервера
      const raw = this.$store.getters['inspector/landingInfo'];
      if (!raw || !raw.content) return null;
      try {
        const jsonStr = raw.content.replace(/<pre><code>|<\/code><\/pre>/g, '');
        return JSON.parse(jsonStr);
      } catch (e) {
        console.error('Ошибка парсинга landingInfo', e);
        return null;
      }
    },
    loading() {
      return this.$store.getters['inspector/landingLoading'];
    },
    error() {
      return this.$store.getters['inspector/landingError'];
    }
  },
  methods: {
    getLandingSuggestions() {
      const landingData = this.$store.getters['landing/landingData'] || [];
      this.$store.dispatch('inspector/GET_LANDING_INFO', landingData);
    },
    save() {
      this.$emit('update:modelValue', false);
    },
    close() {
      this.$emit('update:modelValue', false);
    }
  }
};
</script>


<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  background: #0000008c;
}
.modal-window {
  width: min(920px, 100%);
  background: var(--grey-1);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid rgba(255,255,255,0.03);
}
.close-btn {
  background: transparent;
  border: none;
  font-size: 1.1rem;
  cursor: pointer;
  filter:invert(1)
}
.close-btn:hover {
	opacity: 0.5
}
.modal-body {
  display: flex;
  gap: 1rem;
  padding: 1rem;
	flex-direction: column;
}
.upload-column {
  flex: 1 1 60%;
}
.preview-column {
  width: 240px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
}
.preview-box {
  width: 200px;
  height: 120px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.preview-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-top: 1px solid rgba(255,255,255,0.03);
}
.btn {
  padding: 0.5rem 0.9rem;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 600;
  width: fit-content;
  border: none;
  color: var(--color-0);
}
.btn.primary {
  background: var(--blue-0);
}
.btn.secondary {
  background: var(--grey-1);
}
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.preview-info .name {
  font-weight: 600;
  text-align: center;
  word-break: break-all;
}
.hint {
  color: var(--grey-0);
  font-size: 0.8rem;
  text-align: center;
}
.landing-info.card {
  background: var(--grey-0);
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem 1rem;
}
.info-grid .span-2 {
  grid-column: span 2;
  text-align: left;
}

.recommendations ul {
  margin: 0.5rem 0 0;
  padding-left: 0rem;
  list-style: none;
}
.recommendations h5 {
	text-align: left;
}
.recommendations li {
  margin-bottom: 0.3rem;
	text-align: left;
}

.dependencies,
.score {
  margin-top: 0.5rem;
}

.score-bar {
  width: 100%;
  height: 8px;
  background: rgba(255,255,255,0.1);
  border-radius: 4px;
  overflow: hidden;
  margin: 0.3rem 0;
}
.score-fill {
  height: 100%;
  background: var(--blue-0);
  transition: width 0.4s ease;
}

.hint.error {
  color: #ff6b6b;
}

</style>
